var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "80%",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "100px" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "表名称", prop: "TableName" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "表名称" },
                                model: {
                                  value: _vm.form.TableName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "TableName", $$v)
                                  },
                                  expression: "form.TableName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "表Key", prop: "TableKey" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "表Key", disabled: "" },
                                model: {
                                  value: _vm.form.TableKey,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "TableKey", $$v)
                                  },
                                  expression: "form.TableKey",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "表说明", prop: "Describe" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "表说明",
                                  type: "textarea",
                                  rows: "3",
                                  resize: "none",
                                },
                                model: {
                                  value: _vm.form.Describe,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "Describe", $$v)
                                  },
                                  expression: "form.Describe",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.form.list, height: "calc(100% - 120px)" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "50", type: "index" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "字段名称",
                      align: "center",
                      prop: "FieldName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "字段Key",
                      align: "center",
                      prop: "FieldKey",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "字段类型",
                      align: "center",
                      prop: "ColumnType",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "枚举定义",
                      align: "center",
                      prop: "Enumeration",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                placeholder: "",
                                type: "textarea",
                                rows: "2",
                                resize: "none",
                              },
                              model: {
                                value: scope.row.Enumeration,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "Enumeration", $$v)
                                },
                                expression: "scope.row.Enumeration",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "字段说明",
                      align: "center",
                      prop: "Describe",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                placeholder: "",
                                type: "textarea",
                                rows: "2",
                                resize: "none",
                              },
                              model: {
                                value: scope.row.Describe,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "Describe", $$v)
                                },
                                expression: "scope.row.Describe",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }